/**
 * Target configuration for mission PROTEGER
 * Allows setting keywords and medias to monitor for negative mentions
 */
import React, { useState } from 'react';
import { Box, Typography, TextField, Chip } from '@mui/material';
import { colors } from '../../styles/colors';

const TargetProteger = ({ config = {}, onChange, missionColor }) => {
  const [keywordInput, setKeywordInput] = useState('');
  const [mediaInput, setMediaInput] = useState('');

  const keywords = config.keywords || [];
  const medias = config.medias || [];

  const handleAddKeyword = (e) => {
    if (e.key === 'Enter' && keywordInput.trim()) {
      e.preventDefault();
      const updated = [...keywords, keywordInput.trim()];
      onChange({ ...config, mission: 'proteger', keywords: updated });
      setKeywordInput('');
    }
  };

  const handleRemoveKeyword = (idx) => {
    const updated = keywords.filter((_, i) => i !== idx);
    onChange({ ...config, mission: 'proteger', keywords: updated });
  };

  const handleAddMedia = (e) => {
    if (e.key === 'Enter' && mediaInput.trim()) {
      e.preventDefault();
      const updated = [...medias, mediaInput.trim()];
      onChange({ ...config, mission: 'proteger', medias: updated });
      setMediaInput('');
    }
  };

  const handleRemoveMedia = (idx) => {
    const updated = medias.filter((_, i) => i !== idx);
    onChange({ ...config, mission: 'proteger', medias: updated });
  };

  return (
    <Box sx={{ p: 2, borderLeft: `3px solid ${missionColor}`, borderRadius: 2, bgcolor: colors.ivory }}>
      <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.82rem', fontWeight: 600, color: colors.charcoal, mb: 1.5 }}>
        Ciblage Proteger
      </Typography>

      <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.75rem', color: colors.textMed, mb: 0.5 }}>
        Mots-cles a surveiller (Entree pour ajouter)
      </Typography>
      <TextField
        fullWidth
        size="small"
        placeholder="Ex: scandale, corruption, proces..."
        value={keywordInput}
        onChange={(e) => setKeywordInput(e.target.value)}
        onKeyPress={handleAddKeyword}
        sx={{ mb: 1 }}
      />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
        {keywords.map((kw, idx) => (
          <Chip key={idx} label={kw} size="small" onDelete={() => handleRemoveKeyword(idx)} sx={{ height: 24, fontSize: '0.72rem', fontFamily: '"DM Sans", sans-serif' }} />
        ))}
      </Box>

      <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.75rem', color: colors.textMed, mb: 0.5 }}>
        Medias cibles (Entree pour ajouter)
      </Typography>
      <TextField
        fullWidth
        size="small"
        placeholder="Ex: Jeune Afrique, RFI, Le Monde..."
        value={mediaInput}
        onChange={(e) => setMediaInput(e.target.value)}
        onKeyPress={handleAddMedia}
        sx={{ mb: 1 }}
      />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {medias.map((m, idx) => (
          <Chip key={idx} label={m} size="small" onDelete={() => handleRemoveMedia(idx)} sx={{ height: 24, fontSize: '0.72rem', fontFamily: '"DM Sans", sans-serif' }} />
        ))}
      </Box>
    </Box>
  );
};

export default TargetProteger;
